import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step11', 'Steps', {
	data() {
		return {
			step: null,
			selectedThreshold: 0,
			showStep: false,
		};
	},
	props: ['molding', 'threshold'],
	created() {
		this.getDataStep();
	},
	methods: {
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep11', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step = response.data.result;
					if (!response.data.result.thresholds.length) {
						context.setPropPosition({ step11: 'skip' });
						context.showStep = false;
					} else {
						context.deletePositionKey(['step11']);
						context.showStep = true;
						context.setSelectedTreshold(0);
					}
				}
			});
		},
		isDataStep: function () {
			return this.step;
		},
		setSelectedTreshold(index) {
			this.selectedThreshold = index;
			this.setPropPosition({ threshold: this.step.thresholds[this.selectedThreshold] });
		},
	},
	watch: {
		molding: function (val, oldVal) {
			this.setSelectedTreshold(0);
		},
		threshold(val) {
			if (val === undefined) this.setSelectedTreshold(0);
		},
	},
	template: `
	<div class="config-block" v-if="showStep">
		<div class="config-block__inner" v-if="isDataStep()">
			<div class="config-block__wrap">
				<ConfigBlockWrapTitle tippyContent="Добавить порог">Добавить порог</ConfigBlockWrapTitle>
				<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="2">
					<div class="swiper-slide" v-for="(slide, index) of step.thresholds">
						<SimpleItem :image="slide.image" :title="slide.title" :price="slide.price" :priceType="2" :key="index"
							:class="{active: selectedThreshold === index}" v-on:setActive="setSelectedTreshold(index)" />
					</div>
				</Swiper>
			</div>
		</div>
		<div v-else>
			<div class="config-block__wrap-title">Добавить порог</div>
			<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="2">
				<div class="swiper-slide" v-for="i of [1,2]">
					<PuSkeleton height="220px" />
				</div>
			</Swiper>
		</div>
	</div>
`,
});
